export default class ClubModel {
    id_clube: string | null;
    razao_social: string | null;
    

    constructor(
        id_clube: string | null,
        razao_social: string | null,
        
    ) {
        this.id_clube = id_clube;
        this.razao_social = razao_social;
        
    }

    static fromApiResponse(data: any): ClubModel {
        return new ClubModel(
            data.id_clube || null,
            data.razao_social || null,
        );
    }

    static fromApiResponseArray(dataArray: any[]): ClubModel[] {
        return dataArray.map(data => ClubModel.fromApiResponse(data));
    }
}